const CAROUSEL_ITEMS = [
  {
    title: '暑期档观影指南',
    desc: '2026年暑期档新片一览，动作科幻喜剧动画全收录，帮你规划最佳观影路线',
    img: 'https://readdy.ai/api/search-image?query=Summer%20movie%20themed%20collage%20with%20popcorn%20and%20film%20reels%2C%20warm%20golden%20sunset%20lighting%2C%20cinematic%20festival%20atmosphere%2C%20artistic%20movie%20poster%20style%2C%20rich%20amber%20and%20cream%20tones%2C%20professional%20photography&width=800&height=500&seq=carousel-01&orientation=landscape',
    tag: '观影指南',
  },
  {
    title: '国产悬疑剧天花板',
    desc: '从《隐秘的角落》到《漫长的季节》，盘点那些让人欲罢不能的国产悬疑神作',
    img: 'https://readdy.ai/api/search-image?query=Mystery%20thriller%20atmosphere%20with%20rainy%20window%20and%20detective%20elements%2C%20dark%20warm%20cinematic%20lighting%2C%20film%20noir%20aesthetic%2C%20artistic%20moody%20composition%2C%20deep%20amber%20shadows%2C%20professional%20cinematography%20style&width=800&height=500&seq=carousel-02&orientation=landscape',
    tag: '悬疑专题',
  },
  {
    title: '韩剧必看TOP10',
    desc: '从经典到最新，这些韩剧代表了韩流的巅峰水准，没看过等于白追韩剧',
    img: 'https://readdy.ai/api/search-image?query=Korean%20drama%20romantic%20scene%20with%20warm%20autumn%20leaves%20and%20cozy%20cafe%20setting%2C%20soft%20cinematic%20lighting%2C%20artistic%20film%20poster%20aesthetic%2C%20rich%20warm%20cream%20and%20amber%20tones%2C%20professional%20photography&width=800&height=500&seq=carousel-03&orientation=landscape',
    tag: '韩剧经典',
  },
  {
    title: '科幻电影进化史',
    desc: '从《2001太空漫游》到《流浪地球》，科幻电影如何一次次刷新我们的想象',
    img: 'https://readdy.ai/api/search-image?query=Futuristic%20spaceship%20interior%20with%20holographic%20screens%20and%20warm%20ambient%20light%2C%20sci-fi%20cinematic%20aesthetic%2C%20artistic%20composition%2C%20rich%20golden%20and%20copper%20accents%2C%20professional%20movie%20set%20photography&width=800&height=500&seq=carousel-04&orientation=landscape',
    tag: '科幻探索',
  },
  {
    title: '动画不只是给孩子看的',
    desc: '成年人也爱的动画电影合集，每一部都藏着深刻的主题和惊艳的制作',
    img: 'https://readdy.ai/api/search-image?query=Animated%20film%20style%20scene%20with%20vibrant%20colors%20and%20artistic%20character%20design%2C%20warm%20magical%20lighting%2C%20cinematic%20composition%2C%20studio%20ghibli%20inspired%20aesthetic%2C%20rich%20golden%20and%20soft%20green%20tones%2C%20professional%20animation%20still&width=800&height=500&seq=carousel-05&orientation=landscape',
    tag: '动画精选',
  },
  {
    title: '高能反转电影推荐',
    desc: '结局让你惊掉下巴的高分电影，不到最后一秒永远猜不到真相',
    img: 'https://readdy.ai/api/search-image?query=Dramatic%20twist%20ending%20movie%20scene%20with%20mirror%20reflections%20and%20suspense%20atmosphere%2C%20warm%20cinematic%20lighting%2C%20thriller%20film%20aesthetic%2C%20artistic%20moody%20composition%2C%20rich%20amber%20and%20deep%20shadow%20tones%2C%20professional%20cinematography&width=800&height=500&seq=carousel-06&orientation=landscape',
    tag: '反转神作',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="w-full px-4 md:px-6 py-16 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 text-xs font-medium bg-accent-100 text-accent-700 rounded-full mb-3 whitespace-nowrap">
            专题推荐
          </span>
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 font-heading">
            精选影视专题
          </h2>
          <p className="text-sm text-foreground-500 mt-2">
            深度策划，发现不一样的观影视角
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {CAROUSEL_ITEMS.map((item, i) => (
            <a
              key={i}
              href="#media"
              className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all cursor-pointer"
            >
              <div className="relative aspect-[8/5] overflow-hidden">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/20 to-transparent"></div>
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 text-xs font-medium bg-primary-500 text-background-50 rounded-full whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
              </div>
              <div className="p-5">
                <h3 className="text-base font-bold text-foreground-900 font-heading mb-2 group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed">
                  {item.desc}
                </p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}